import React from 'react';
import { useSelector } from 'react-redux';
import StepHeader from '~/components/shared/Stepper/components/StepHeader';
import { useGetBankAccountsQuery } from '~/store/apis/endpoints/onboardingApi/onboarding.api';
import { RootState } from '~/store';

const BankInformationHeader = () => {
  const { bankAccounts, clientId } = useSelector(
    (state: RootState) => state.loanOffer.overview
  );
  const { data: openBankingAccounts } = useGetBankAccountsQuery(
    { clientId },
    {
      skip: !clientId,
    }
  );

  const title = 'OnboardingOffer.ConfirmBankAccountTitle';
  const hasBankAccountsViaKlarnaKosma = Boolean(bankAccounts?.length);
  const hasBankAccountsViaOpenBanking = Boolean(openBankingAccounts?.length);

  const hasBankAccounts =
    hasBankAccountsViaKlarnaKosma || hasBankAccountsViaOpenBanking;
  const description = hasBankAccounts
    ? 'OnboardingOffer.ConfirmBankAccountDescriptionIfExist'
    : 'OnboardingOffer.ConfirmBankAccountDescriptionIfNotExist';

  return <StepHeader title={title} description={description} />;
};

export default BankInformationHeader;
